function SvgHdmi(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 29 11" {...props}>
      <path d="M1.96 0L.793 1.169v6.505l1.169 1.168h2.293l2.21 1.474h16.657l2.21-1.474h2.293l1.168-1.168V1.169L27.624 0H1.96zm.306 7.063V1.78l.305-.305h24.443l.305.305v5.284l-.305.305h-2.129l-2.21 1.474H6.91L4.7 7.368H2.57l-.305-.305z" />
      <path d="M4.477 5.158h20.631V3.684H4.477z" />
    </svg>
  );
}

export default SvgHdmi;
